package dev.lingvo.site.pages.app.projects.slug.settings

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import dev.lingvo.site.ds.LoadingState
import dev.lingvo.site.i18n.t

/**
 * Compatibility route for old links.
 *
 * Provider configuration has one implementation: the canonical Translation providers tab on the
 * project settings route. Keeping a second editor here would let mode, readiness and secret-field
 * behavior drift again.
 */
@Page("/app/projects/{slug}/settings/providers")
@Layout(".components.layouts.AppLayout")
@Composable
fun ProjectProvidersPage() {
    val ctx = rememberPageContext()
    val slug = ctx.route.params["slug"].orEmpty()
    LaunchedEffect(slug) {
        ctx.router.tryRoutingTo("/app/projects/$slug/settings?tab=providers")
    }
    LoadingState(rows = 2, label = t("app.projects.slug.settings.providers.opening_translation_providers", "Opening translation providers"))
}
